<template>
    <div id="create-leak-rule-page" class="dashboard-view">
        <div class="container">
            <section class="content">
                <h1>Add Leak Rule</h1>
                <LeakRuleForm @formSubmitted="createRule" />
            </section>
        </div>
    </div>
</template>

<script>
import LeakRuleForm from '@/components/forms/LeakRuleForm.vue'

const endpoint = process.env.VUE_APP_API_BASE + '/leak-rules/create'
import axios from 'axios'

export default {
    name: 'LeakRulesCreate',
    components: {
        LeakRuleForm
    },
    data: function () {
        return {}
    },
    methods: {
        createRule(data) {
            axios.post(endpoint, data)
                .then(response => {
                    console.log(response)
                    alert('Leak rule created successfully')
                    this.$router.push('/leak-rules')
                })
                .catch(error => {
                    console.log(error.response)
                    if (error.response && error.response.data?.data) {
                        alert(error.response.data.data)
                    } else {
                        alert('Error occurred!')
                        console.log(error)
                    }
                })
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
